// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"6e62f853","453":"7258587f","674":"1f1ebf61"}[chunkId] + ".chunk.js";
};